import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { FaBrain, FaPalette, FaBolt } from "react-icons/fa";
import SectionContainer from "./SectionContainer";
import { techFeatures } from "../../data/landingData";

const icons = {
  llm: FaBrain,
  visual: FaPalette,
  delivery: FaBolt,
};

const TechFeaturesSection: React.FC = () => {
  const { t } = useTranslation("home");

  return (
    <SectionContainer>
      <motion.h2
        className="text-h2 text-center mb-10 text-white"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        {t("features_title")}
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
        {techFeatures.map((feature, index) => {
          const Icon = icons[feature.icon];

          return (
            <motion.div
              key={feature.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.08 }}
              className="rounded-2xl border border-white/10 bg-space-light/40 p-5 md:p-6"
            >
              <div className="w-12 h-12 rounded-xl bg-gradient-brand flex items-center justify-center glow-green mb-4">
                <Icon className="text-space text-xl" />
              </div>
              <h3 className="text-h4 text-neon-green mb-2 leading-snug">
                {t(`feature_${feature.id}_title`)}
              </h3>
              <p className="text-body-sm text-gray-400 leading-relaxed">
                {t(`feature_${feature.id}_desc`)}
              </p>
            </motion.div>
          );
        })}
      </div>
    </SectionContainer>
  );
};

export default TechFeaturesSection;
